// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productUnitOfMeasureSelectStyles } from "@awc/Overrides/Components/ProductUnitOfMeasureSelect";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color } from "@awc/XDL/Utilities";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

productUnitOfMeasureSelectStyles.wrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 10px;
        > div {
            display: inline-flex;
            align-items: center;
            background: ${color("common.white")};
            padding: 2px 8px;
            border-radius: 15px;
            border: 1px solid ${color("common.ui4")};
            color: ${color("common.ui4")};
            height: 20px;
            ${TypographyStyle} {
                font-size: ${fontConfig.fontSize.xSmall}px;
                line-height: ${fontConfig.lineHeight.singleLinexxSmall};
            }
            cursor: pointer;
            &.selected {
                color: ${color("common.white")};
                background: ${color("common.ui9")};
            }
        }
    `,
};

productUnitOfMeasureSelectStyles.attribute = {
    size: fontConfig.fontSize.small,
    lineHeight: fontConfig.lineHeight.singleLineSmall,
    weight: fontConfig.weight.bold,
    css: css`
        display: block;
        margin-bottom: 9px;
    `,
};
